<h1 mat-dialog-title>
  {{ 'map.sidebar.fibra.history' | translate : { name: fibra?.fiber_number || fibra?.id_fibra_gis || ' ' } }}
</h1>

<div mat-dialog-content>
  <div class="d-flex align-items-center gap-2 history-toolbar">
    <div class="info-box info-history">
      <mat-icon class="info-box__icon">info_outline</mat-icon>
      <div class="info-box__text">{{ 'map.sidebar.fibra.history_note' | translate }}</div>
    </div>

    <button
      mat-mini-fab
      color="accent"
      [matMenuTriggerFor]="menu"
      [matTooltip]="'map.map_table.export' | translate"
      matTooltipPosition="above"
    >
      <mat-icon>download</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onExport('html')">
        {{ 'map.map_table.export_html' | translate }}
      </button>
      <button mat-menu-item (click)="onExport('csv')">
        {{ 'map.map_table.export_csv' | translate }}
      </button>
    </mat-menu>
  </div>

  <div class="map-table-content">
    <mtx-grid
      #grid
      [data]="dataGrid"
      [columns]="columnsGrid"
      [showColumnMenuHeader]="false"
      [noResultText]="'common.no_result' | translate"
      [showFirstLastButtons]="false"
      [rowStriped]="true"
      [showPaginator]="true"
      [emptyValuePlaceholder]="'-'"
      [pageSize]="pageSize"
      [pageOnFront]="false"
      [pageIndex]="currentPageIndex"
      [pageSizeOptions]="pageSizeOptions"
      [length]="totalCount"
      [sortOnFront]="false"
      [sortDisabled]="false"
      sortStart="asc"
      (sortChange)="onSortChange($event)"
      (page)="onPageChange($event)"
    >
    </mtx-grid>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="false" color="primary">{{ 'common.close' | translate }}</button>
</div>
